import React, { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const GSAPFeatureSection = ({ features }) => {
  const sectionRefs = useRef([]);
  const [activeFeature, setActiveFeature] = useState(0);

  useEffect(() => {
    sectionRefs.current.forEach((ref, index) => {
      gsap.fromTo(
        ref,
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          scrollTrigger: {
            trigger: ref,
            start: "top center",
            end: "bottom center",
            onEnter: () => setActiveFeature(index),
            onEnterBack: () => setActiveFeature(index),
            toggleActions: "play none none reverse",
          },
        }
      );
    });
  }, []);

  return (
    <div className="scroll-feature-section">
      <div className="feature-static-heading sticky-top">
        <h3>
          Smart Fleet Management
          <br />
          Enhancing Safety and Efficiency with <br /> <i>Real Time Alerts</i>
        </h3>
        <h3 className="mt-5">
          Cab<span style={{ color: "orange" }}>In</span>{" "}
          <span style={{ fontWeight: 300 }}>Alerts</span>
          <sup style={{ fontWeight: 500, fontSize: "10px" }}>TM</sup>
        </h3>
      </div>
      {features?.map((feature, index) => (
        <div
          key={index}
          ref={(el) => (sectionRefs.current[index] = el)}
          className={`feature-section ${
            index === activeFeature ? "active" : ""
          }`}
        >
          <div className="feature-content">
            <h2>{feature.title}</h2>
            <p>{feature.description}</p>
          </div>
          <div className="feature-video">
            <video
              src={feature.videoSrc}
              autoPlay
              loop
              muted
              playsInline
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default GSAPFeatureSection;
